import React      from 'react';
import CSSModules from 'react-css-modules';
import Helmet     from "react-helmet";

import Footer  from '../Footer';
import Header  from '../Header';
import Cookie from '../../services/cookies';

import style from './style.scss';

class Page extends React.Component {

    _getContentStyleName() {
        if (this.props.location.pathname.includes('/booking/')) {
            return "booking-content";
        }

        return "content";
    }

    render() {

        return (
            <div styleName="page">

                <Helmet defaultTitle="RHE Training"
                        titleTemplate="%s | RHE Training" />

                <div styleName="wrapper">

                    <Header pathName={ this.props.location.pathname } />

                    <div styleName={this._getContentStyleName()}>

                        { this.props.children }

                    </div>

                    <div styleName="footer-push" ></div>

                </div>

                <Footer />

            </div>
        );
    }
}

export default CSSModules(Page, style);


// WEBPACK FOOTER //
// ./components/Page/index.js